// Kabin Memurluğu Eğitimi - Müfredat Yapısı
// Türkçe Mesleki Eğitim - Mülakat Hazırlık Odaklı

export const cabinCrewCurriculum = {
  program_name: "Kabin Memurluğu Temel + Mülakat Hazırlık",
  passing_score: 70,
  total_modules: 10,
  
  modules: {
    module_1: {
      id: 'module_1',
      module_id: 1,
      title: 'Kabin Memurluğuna Giriş',
      subtitle: 'Mesleğin gerçek tanımı',
      icon: '✈️',
      color: 'from-blue-500 to-indigo-600',
      bgColor: 'bg-blue-500',
      estimatedTime: 60,
      totalUnits: 6,
      units: [
        {
          id: 1,
          unit_id: 'CM-M1-U1',
          title: 'Mesleğin Gerçek Tanımı',
          description: 'Kabin memurluğu sizin için ne ifade ediyor?',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M1-U1-L1', title: 'Kabin Memurluğu Nedir?', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M1-U1-L2', title: 'Güvenlik Sorumluluğu', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M1-U1-L3', title: 'Senaryo: Meslek Algısı', type: 'scenario', duration: 5, xp: 30 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M1-U2',
          title: 'Havacılık Sektörü',
          description: 'Sektörün yapısı ve işleyişi',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M1-U2-L1', title: 'Havayolu Şirketleri', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M1-U2-L2', title: 'Kariyer Yolları', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M1-U2-L3', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M1-U3',
          title: 'Günlük Hayat',
          description: 'Kabin memurunun günü nasıl geçer?',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M1-U3-L1', title: 'Bir Günün Anatomisi', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M1-U3-L2', title: 'Çalışma Saatleri ve Rotasyon', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M1-U3-L3', title: 'Layover Hayatı', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M1-U3-L4', title: 'Senaryo: Tipik Bir Hafta', type: 'scenario', duration: 8, xp: 40 },
            { id: 5, lesson_id: 'CM-M1-U3-L5', title: '🎮 Günlük Rutin Eşleştir', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M1-U4',
          title: 'Kariyer Yolculuğu',
          description: 'Yükselme ve gelişim fırsatları',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M1-U4-L1', title: 'Kariyer Basamakları', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M1-U4-L2', title: 'Farklı Havayolu Türleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M1-U4-L3', title: 'Maaş ve Yan Haklar', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M1-U4-L4', title: '⚡ Kariyer Yarışı', type: 'timerace', duration: 4, xp: 45 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M1-U5',
          title: 'Mesleğin Zorlukları',
          description: 'Fiziksel ve duygusal zorluklar',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M1-U5-L1', title: 'Fiziksel Zorluklar', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M1-U5-L2', title: 'Duygusal Zorluklar', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M1-U5-L3', title: 'Senaryo: Zor Karar', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M1-U5-L4', title: '🎮 Doğru mu Yanlış mı?', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M1-U6',
          title: '🎓 Final Quiz',
          description: 'Modül değerlendirmesi',
          type: 'exam',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M1-U6-L1', title: 'Genel Tekrar', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M1-U6-L2', title: '🎓 Modül 1 Final Sınavı', type: 'exam', duration: 10, xp: 80 },
          ]
        },
      ]
    },
    
    module_2: {
      id: 'module_2',
      module_id: 2,
      title: 'Havayolları Adaydan Ne Bekler?',
      subtitle: 'Değerlendirme kriterleri',
      icon: '🎯',
      color: 'from-emerald-500 to-teal-600',
      bgColor: 'bg-emerald-500',
      estimatedTime: 55,
      totalUnits: 6,
      units: [
        {
          id: 1,
          unit_id: 'CM-M2-U1',
          title: 'Değerlendirme Kriterleri',
          description: 'Grup mülakatlarında en önemli kriterler',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M2-U1-L1', title: 'Takım Uyumu', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M2-U1-L2', title: 'İletişim Becerileri', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M2-U1-L3', title: 'Senaryo: Kriter Testi', type: 'scenario', duration: 5, xp: 30 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M2-U2',
          title: 'Fiziksel Gereklilikler',
          description: 'Boy, kilo, sağlık kriterleri',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M2-U2-L1', title: 'Boy ve Erişim Mesafesi', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M2-U2-L2', title: 'Sağlık Gereksinimleri', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M2-U2-L3', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M2-U3',
          title: 'Kişilik Özellikleri',
          description: 'Empati, esneklik, stres yönetimi',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M2-U3-L1', title: 'Aranan Kişilik Özellikleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M2-U3-L2', title: 'Kültürel Farkındalık', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M2-U3-L3', title: 'Senaryo: Kültürel Durum', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M2-U3-L4', title: '🎮 Kişilik Eşleştirme', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M2-U4',
          title: 'Dil ve İletişim',
          description: 'İngilizce ve iletişim becerileri',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M2-U4-L1', title: 'İngilizce Gereksinimleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M2-U4-L2', title: 'İkinci Dil Avantajı', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M2-U4-L3', title: 'Etkili İletişim Teknikleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M2-U4-L4', title: '⚡ Dil Bilgisi Yarışı', type: 'timerace', duration: 4, xp: 45 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M2-U5',
          title: 'Görünüm ve Grooming',
          description: 'Profesyonel görünüm standartları',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M2-U5-L1', title: 'Grooming Standartları', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M2-U5-L2', title: 'Mülakat Görünümü', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M2-U5-L3', title: '🎮 Grooming Doğru/Yanlış', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M2-U6',
          title: '🎓 Final Quiz',
          description: 'Modül değerlendirmesi',
          type: 'exam',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M2-U6-L1', title: '🎓 Modül 2 Final Sınavı', type: 'exam', duration: 10, xp: 80 },
          ]
        },
      ]
    },
    
    module_3: {
      id: 'module_3',
      module_id: 3,
      title: 'Aday Nasıl Davranmalı?',
      subtitle: 'Grup dinamiği ve davranış',
      icon: '🤝',
      color: 'from-purple-500 to-pink-600',
      bgColor: 'bg-purple-500',
      estimatedTime: 60,
      totalUnits: 6,
      units: [
        {
          id: 1,
          unit_id: 'CM-M3-U1',
          title: 'Grup Dinamiği',
          description: 'Grup çalışmasında doğru davranış',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M3-U1-L1', title: 'Aktif Dinleme', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M3-U1-L2', title: 'Katkı Sağlama', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M3-U1-L3', title: 'Senaryo: Sessiz Grup', type: 'scenario', duration: 5, xp: 30 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M3-U2',
          title: 'Denge Kurma',
          description: 'Liderlik vs takım oyuncusu',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M3-U2-L1', title: 'Ne Baskın Ne Pasif', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M3-U2-L2', title: 'Orta Yol Bulma', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M3-U2-L3', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M3-U3',
          title: 'İletişim Stratejileri',
          description: 'Sözsüz iletişim ve konuşma',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M3-U3-L1', title: 'Sözsüz İletişim', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M3-U3-L2', title: 'Etkili Konuşma Teknikleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M3-U3-L3', title: 'Senaryo: Zor Soru Anı', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M3-U3-L4', title: '🎮 İletişim Eşleştirme', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M3-U4',
          title: 'Grup İçi Roller',
          description: 'Lider, koordinatör, destekçi',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M3-U4-L1', title: 'Grup Mülakatında Roller', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M3-U4-L2', title: 'Rekabet vs İşbirliği', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M3-U4-L3', title: 'Senaryo: Baskın Aday', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M3-U4-L4', title: '⚡ Rol Yarışı', type: 'timerace', duration: 4, xp: 45 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M3-U5',
          title: 'Pratik Senaryolar',
          description: 'Sık yapılan hatalar',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M3-U5-L1', title: 'Sık Yapılan Hatalar', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M3-U5-L2', title: 'Senaryo: Fikir Çatışması', type: 'scenario', duration: 8, xp: 40 },
            { id: 3, lesson_id: 'CM-M3-U5-L3', title: '🎮 Hata Bul: Doğru/Yanlış', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M3-U6',
          title: '🎓 Final Quiz',
          description: 'Modül değerlendirmesi',
          type: 'exam',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M3-U6-L1', title: '🎓 Modül 3 Final Sınavı', type: 'exam', duration: 10, xp: 80 },
          ]
        },
      ]
    },
    
    module_4: {
      id: 'module_4',
      module_id: 4,
      title: 'Kritik Hatalar',
      subtitle: 'Ne yapılmamalı?',
      icon: '⚠️',
      color: 'from-red-500 to-orange-600',
      bgColor: 'bg-red-500',
      estimatedTime: 55,
      totalUnits: 6,
      units: [
        {
          id: 1,
          unit_id: 'CM-M4-U1',
          title: 'Ezber ve Aşırı Özgüven',
          description: 'Ezber cevaplar neden riskli?',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M4-U1-L1', title: 'Ezber vs Doğallık', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M4-U1-L2', title: 'Gerçek Refleks', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M4-U1-L3', title: 'Senaryo: Ezber Testi', type: 'scenario', duration: 5, xp: 30 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M4-U2',
          title: 'Yaygın Hatalar',
          description: 'Adayların yaptığı hatalar',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M4-U2-L1', title: 'Aşırı Konuşma', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M4-U2-L2', title: 'Yetersiz Hazırlık', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M4-U2-L3', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M4-U3',
          title: 'Davranış Hataları',
          description: 'Beden dili ve iletişim hataları',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M4-U3-L1', title: 'Negatif Beden Dili', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M4-U3-L2', title: 'Yanlış İletişim', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M4-U3-L3', title: 'Senaryo: Kötü İzlenimler', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M4-U3-L4', title: '🎮 Hata Bul Quiz', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M4-U4',
          title: 'Hazırlık Hataları',
          description: 'Araştırma ve lojistik hatalar',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M4-U4-L1', title: 'Araştırma Eksikliği', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M4-U4-L2', title: 'Pratik Eksikliği', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M4-U4-L3', title: 'Lojistik Hatalar', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M4-U4-L4', title: '⚡ Hata Yarışı', type: 'timerace', duration: 4, xp: 45 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M4-U5',
          title: 'Psikolojik Tuzaklar',
          description: 'Stres ve kararsızlık',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M4-U5-L1', title: 'Aşırı Stres Yönetimi', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M4-U5-L2', title: 'Kararsızlık ve Aşırı Düşünme', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M4-U5-L3', title: 'Senaryo: Panik Anı', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M4-U5-L4', title: '🎮 Stres Eşleştirme', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M4-U6',
          title: '🎓 Final Quiz',
          description: 'Modül değerlendirmesi',
          type: 'exam',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M4-U6-L1', title: '🎓 Modül 4 Final Sınavı', type: 'exam', duration: 10, xp: 80 },
          ]
        },
      ]
    },
    
    module_5: {
      id: 'module_5',
      module_id: 5,
      title: 'Gerçek Mülakat Soruları',
      subtitle: 'Zor senaryolar',
      icon: '❓',
      color: 'from-amber-500 to-yellow-600',
      bgColor: 'bg-amber-500',
      estimatedTime: 75,
      totalUnits: 7,
      units: [
        {
          id: 1,
          unit_id: 'CM-M5-U1',
          title: 'Zor Yolcu Senaryosu',
          description: 'Zor yolcu ile nasıl başa çıkılır?',
          type: 'scenario',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M5-U1-L1', title: 'Empati Kurma', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M5-U1-L2', title: 'Prosedür Takibi', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M5-U1-L3', title: 'Senaryo: Zor Yolcu', type: 'scenario', duration: 10, xp: 50 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M5-U2',
          title: 'Acil Durum Soruları',
          description: 'Kriz anında karar verme',
          type: 'scenario',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M5-U2-L1', title: 'Öncelik Belirleme', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M5-U2-L2', title: 'Ekip Koordinasyonu', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M5-U2-L3', title: 'Senaryo: Acil Durum', type: 'scenario', duration: 10, xp: 50 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M5-U3',
          title: 'Motivasyon Soruları',
          description: 'Neden kabin memuru?',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M5-U3-L1', title: 'Neden Kabin Memuru?', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M5-U3-L2', title: 'Neden Bu Havayolu?', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M5-U3-L3', title: 'Senaryo: Motivasyon Testi', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M5-U3-L4', title: '🎮 Sürükle-Bırak: Doğru Cevap', type: 'dragdrop', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M5-U4',
          title: 'Senaryo Bazlı Sorular',
          description: 'Zor yolcular ve acil durumlar',
          type: 'scenario',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M5-U4-L1', title: 'Zor Yolcu Türleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M5-U4-L2', title: 'Tıbbi Acil Durumlar', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M5-U4-L3', title: 'Senaryo: Türbülans Krizi', type: 'scenario', duration: 10, xp: 50 },
            { id: 4, lesson_id: 'CM-M5-U4-L4', title: '🎮 Acil Durum Eşleştirme', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M5-U5',
          title: 'Kişisel Sorular',
          description: 'Güçlü/zayıf yönler, 5 yıl',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M5-U5-L1', title: 'Güçlü ve Zayıf Yönler', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M5-U5-L2', title: '5 Yıl Sonra Nerede?', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M5-U5-L3', title: 'Senaryo: Provokasyon Sorusu', type: 'scenario', duration: 8, xp: 40 },
            { id: 4, lesson_id: 'CM-M5-U5-L4', title: '⚡ Kişisel Soru Yarışı', type: 'timerace', duration: 4, xp: 45 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M5-U6',
          title: 'Ekip Çalışması Soruları',
          description: 'Takım içi anlaşmazlıklar',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M5-U6-L1', title: 'Ekip İçi Çatışma', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M5-U6-L2', title: 'Senaryo: Zor Meslektaş', type: 'scenario', duration: 8, xp: 40 },
            { id: 3, lesson_id: 'CM-M5-U6-L3', title: '🎮 STAR Eşleştirme', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 7,
          unit_id: 'CM-M5-U7',
          title: '🎓 Final Quiz',
          description: 'Modül değerlendirmesi',
          type: 'exam',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M5-U7-L1', title: '🎓 Modül 5 Final Sınavı', type: 'exam', duration: 15, xp: 100 },
          ]
        },
      ]
    },
    
    module_6: {
      id: 'module_6',
      module_id: 6,
      title: 'Mülakat Psikolojisi',
      subtitle: 'Stres yönetimi ve özgüven',
      icon: '🧠',
      color: 'from-cyan-500 to-blue-600',
      bgColor: 'bg-cyan-500',
      estimatedTime: 70,
      totalUnits: 7,
      units: [
        {
          id: 1,
          unit_id: 'CM-M6-U1',
          title: 'Eleştiri Karşısında Tutum',
          description: 'Geri bildirim alma',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M6-U1-L1', title: 'Savunmacı Olmamak', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M6-U1-L2', title: 'Gelişim Odaklılık', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M6-U1-L3', title: 'Senaryo: Eleştiri', type: 'scenario', duration: 5, xp: 30 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M6-U2',
          title: 'Stres Yönetimi',
          description: 'Baskı altında performans',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M6-U2-L1', title: 'Nefes Teknikleri', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M6-U2-L2', title: 'Pozitif Düşünce', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M6-U2-L3', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M6-U3',
          title: 'Özgüven Geliştirme',
          description: 'Gerçek vs sahte özgüven',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M6-U3-L1', title: 'Özgüven Nedir?', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M6-U3-L2', title: 'Sahte vs Gerçek Özgüven', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M6-U3-L3', title: 'Özgüven Egzersizleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M6-U3-L4', title: 'Senaryo: Özgüven Testi', type: 'scenario', duration: 8, xp: 40 },
            { id: 5, lesson_id: 'CM-M6-U3-L5', title: '🎮 Özgüven Doğru/Yanlış', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M6-U4',
          title: 'Beden Dili Okuma',
          description: 'Eller, yüz, duruş',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M6-U4-L1', title: 'Beden Dili Temelleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M6-U4-L2', title: 'El Hareketleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M6-U4-L3', title: 'Yüz İfadeleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M6-U4-L4', title: 'Senaryo: Beden Dili', type: 'scenario', duration: 8, xp: 40 },
            { id: 5, lesson_id: 'CM-M6-U4-L5', title: '🎮 Beden Dili Eşleştir', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M6-U5',
          title: 'Duygusal Zeka',
          description: 'EQ ve empati',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M6-U5-L1', title: 'Duygusal Zeka (EQ)', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M6-U5-L2', title: 'Empati Geliştirme', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M6-U5-L3', title: 'Senaryo: Duygusal Durum', type: 'scenario', duration: 8, xp: 45 },
            { id: 4, lesson_id: 'CM-M6-U5-L4', title: '⚡ EQ Zaman Yarışı', type: 'timerace', duration: 4, xp: 50 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M6-U6',
          title: 'Başarısızlık Yönetimi',
          description: 'Red ve growth mindset',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M6-U6-L1', title: 'Red Cevabı Almak', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M6-U6-L2', title: 'Growth Mindset', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M6-U6-L3', title: 'Senaryo: Zor Soru', type: 'scenario', duration: 8, xp: 45 },
            { id: 4, lesson_id: 'CM-M6-U6-L4', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 50 },
          ]
        },
        {
          id: 7,
          unit_id: 'CM-M6-U7',
          title: 'Mülakat Öncesi Hazırlık',
          description: 'Bir gün önce ve sabahı',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M6-U7-L1', title: 'Bir Gün Önce', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M6-U7-L2', title: 'Mülakat Sabahı', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M6-U7-L3', title: 'Bekleme Odasında', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M6-U7-L4', title: '🎮 Hazırlık Sıralaması', type: 'dragdrop', duration: 4, xp: 40 },
            { id: 5, lesson_id: 'CM-M6-U7-L5', title: '⚡ Hazırlık Yarışı', type: 'timerace', duration: 4, xp: 45 },
          ]
        },
      ]
    },
    
    module_7: {
      id: 'module_7',
      module_id: 7,
      title: 'Dış Görünüm ve İmaj',
      subtitle: 'İlk izlenim',
      icon: '👔',
      color: 'from-pink-500 to-rose-600',
      bgColor: 'bg-pink-500',
      estimatedTime: 20,
      totalUnits: 4,
      units: [
        {
          id: 1,
          unit_id: 'CM-M7-U1',
          title: 'İlk İzlenim',
          description: 'İlk 30 saniye neden kritik?',
          type: 'scenario',
          score: 5,
          lessons: [
            { id: 1, lesson_id: 'CM-M7-U1-L1', title: 'Profesyonel Görünüm', type: 'lesson', duration: 5, xp: 15 },
            { id: 2, lesson_id: 'CM-M7-U1-L2', title: 'Beden Dili', type: 'lesson', duration: 5, xp: 15 },
            { id: 3, lesson_id: 'CM-M7-U1-L3', title: 'Senaryo: İlk İzlenim', type: 'scenario', duration: 5, xp: 25 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M7-U2',
          title: 'Grooming Standartları',
          description: 'Havayolu standartları',
          type: 'lesson',
          score: 5,
          lessons: [
            { id: 1, lesson_id: 'CM-M7-U2-L1', title: 'Saç ve Makyaj', type: 'lesson', duration: 5, xp: 15 },
            { id: 2, lesson_id: 'CM-M7-U2-L2', title: 'Kıyafet Seçimi', type: 'lesson', duration: 5, xp: 15 },
            { id: 3, lesson_id: 'CM-M7-U2-L3', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 30 },
          ]
        },
      ]
    },
    
    module_8: {
      id: 'module_8',
      module_id: 8,
      title: 'Grup Mülakatı Simülasyonu',
      subtitle: 'Pratik uygulama',
      icon: '👥',
      color: 'from-indigo-500 to-violet-600',
      bgColor: 'bg-indigo-500',
      estimatedTime: 90,
      totalUnits: 7,
      units: [
        {
          id: 1,
          unit_id: 'CM-M8-U1',
          title: 'Problem Çözme',
          description: 'Ekip içi anlaşmazlık',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M8-U1-L1', title: 'Tarafsız Kalma', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M8-U1-L2', title: 'Ortak Çözüm', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M8-U1-L3', title: 'Simülasyon: Anlaşmazlık', type: 'scenario', duration: 10, xp: 40 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M8-U2',
          title: 'Sunum Yapma',
          description: 'Grup önünde konuşma',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M8-U2-L1', title: 'Özgüvenli Duruş', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M8-U2-L2', title: 'Etkili Anlatım', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M8-U2-L3', title: 'Simülasyon: Sunum', type: 'scenario', duration: 10, xp: 40 },
            { id: 4, lesson_id: 'CM-M8-U2-L4', title: '⚡ Zaman Yarışı', type: 'timerace', duration: 3, xp: 50 },
            { id: 5, lesson_id: 'CM-M8-U2-L5', title: '🎮 Eşleştir: Sunum', type: 'matching', duration: 3, xp: 30 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M8-U3',
          title: 'Grup Dinamikleri',
          description: 'Roller ve davranışlar',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M8-U3-L1', title: 'Grup Rolleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M8-U3-L2', title: 'Sessiz Adayları Dahil Etme', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M8-U3-L3', title: 'Baskın Adaylarla Başa Çıkma', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M8-U3-L4', title: 'Senaryo: Baskın Aday', type: 'scenario', duration: 10, xp: 50 },
            { id: 5, lesson_id: 'CM-M8-U3-L5', title: '🎮 Grup Rolleri Eşleştir', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M8-U4',
          title: 'Anlaşmazlık Yönetimi',
          description: 'Fikir ayrılıkları',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M8-U4-L1', title: 'Fikir Ayrılığı', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M8-U4-L2', title: 'Uzlaşma Teknikleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M8-U4-L3', title: 'Senaryo: Anlaşmazlık', type: 'scenario', duration: 10, xp: 50 },
            { id: 4, lesson_id: 'CM-M8-U4-L4', title: '⚡ Uzlaşma Yarışı', type: 'timerace', duration: 4, xp: 45 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M8-U5',
          title: 'Sözlü İletişim',
          description: 'Konuşma ve dinleme',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M8-U5-L1', title: 'Etkili Konuşma', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M8-U5-L2', title: 'Aktif Dinleme', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M8-U5-L3', title: 'Fikir Sunumu', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M8-U5-L4', title: 'Senaryo: Fikir Sunumu', type: 'scenario', duration: 8, xp: 45 },
            { id: 5, lesson_id: 'CM-M8-U5-L5', title: '🎮 Boşluk Doldur: İletişim', type: 'fillin', duration: 4, xp: 35 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M8-U6',
          title: 'Aktivite Tipleri',
          description: 'Sorun çözme, yaratıcılık',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M8-U6-L1', title: 'Sorun Çözme Aktivitesi', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M8-U6-L2', title: 'Yaratıcılık Aktivitesi', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M8-U6-L3', title: 'Tartışma Aktivitesi', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M8-U6-L4', title: 'Senaryo: Yaratıcılık', type: 'scenario', duration: 10, xp: 50 },
            { id: 5, lesson_id: 'CM-M8-U6-L5', title: '⚡ Aktivite Yarışı', type: 'timerace', duration: 4, xp: 50 },
          ]
        },
        {
          id: 7,
          unit_id: 'CM-M8-U7',
          title: '🎓 Final Simülasyonlar',
          description: 'Tam simülasyonlar',
          type: 'exam',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M8-U7-L1', title: 'Tam Simülasyon 1', type: 'scenario', duration: 15, xp: 60 },
            { id: 2, lesson_id: 'CM-M8-U7-L2', title: 'Tam Simülasyon 2', type: 'scenario', duration: 15, xp: 60 },
            { id: 3, lesson_id: 'CM-M8-U7-L3', title: 'Tam Simülasyon 3', type: 'scenario', duration: 15, xp: 60 },
            { id: 4, lesson_id: 'CM-M8-U7-L4', title: '🎓 Grup Mülakatı Final Quiz', type: 'exam', duration: 10, xp: 80 },
          ]
        },
      ]
    },
    
    module_9: {
      id: 'module_9',
      module_id: 9,
      title: 'Birebir Mülakat Simülasyonu',
      subtitle: 'HR görüşmesi',
      icon: '🎤',
      color: 'from-teal-500 to-emerald-600',
      bgColor: 'bg-teal-500',
      estimatedTime: 120,
      totalUnits: 8,
      units: [
        {
          id: 1,
          unit_id: 'CM-M9-U1',
          title: 'Motivasyon Sorusu',
          description: 'Neden kabin memuru?',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U1-L1', title: 'Profesyonel Motivasyon', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M9-U1-L2', title: 'Yüzeysel Cevaplardan Kaçınma', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M9-U1-L3', title: 'Simülasyon: Motivasyon', type: 'scenario', duration: 10, xp: 40 },
            { id: 4, lesson_id: 'CM-M9-U1-L4', title: '🎮 Sırala: Motivasyon Cevabı', type: 'dragdrop', duration: 3, xp: 30 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M9-U2',
          title: 'Kendini Tanıtma',
          description: 'Tell me about yourself',
          type: 'scenario',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U2-L1', title: 'Yapılandırılmış Cevap', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M9-U2-L2', title: 'Güçlü Yönler', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M9-U2-L3', title: 'Simülasyon: Tanıtım', type: 'scenario', duration: 10, xp: 40 },
            { id: 4, lesson_id: 'CM-M9-U2-L4', title: '🎮 Doğru mu Yanlış mı?', type: 'truefalse', duration: 3, xp: 25 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M9-U3',
          title: 'STAR Metodu',
          description: 'Davranışsal sorular',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U3-L1', title: 'Situation-Task', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M9-U3-L2', title: 'Action-Result', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M9-U3-L3', title: 'Ünite Sınavı', type: 'quiz', duration: 5, xp: 40 },
            { id: 4, lesson_id: 'CM-M9-U3-L4', title: '⚡ Zaman Yarışı', type: 'timerace', duration: 3, xp: 50 },
            { id: 5, lesson_id: 'CM-M9-U3-L5', title: '🎮 Boşluk Doldur', type: 'fillin', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M9-U4',
          title: 'Davranışsal Sorular',
          description: 'Geçmiş deneyim soruları',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U4-L1', title: 'Davranışsal Soru Nedir?', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M9-U4-L2', title: 'Zor Müşteri Sorusu', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M9-U4-L3', title: 'Ekip Anlaşmazlığı Sorusu', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M9-U4-L4', title: 'Senaryo: Davranışsal Soru', type: 'scenario', duration: 10, xp: 50 },
            { id: 5, lesson_id: 'CM-M9-U4-L5', title: '🎮 Davranışsal Sorular Quiz', type: 'quiz', duration: 5, xp: 45 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M9-U5',
          title: 'Zor Sorular',
          description: 'Zayıf yön, maaş, 5 yıl',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U5-L1', title: 'Zayıf Yön Sorusu', type: 'lesson', duration: 5, xp: 30 },
            { id: 2, lesson_id: 'CM-M9-U5-L2', title: 'Maaş Beklentisi Sorusu', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M9-U5-L3', title: '5 Yıl Sonra Sorusu', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M9-U5-L4', title: 'Neden Sizi Seçelim Sorusu', type: 'lesson', duration: 5, xp: 30 },
            { id: 5, lesson_id: 'CM-M9-U5-L5', title: 'Senaryo: Zor Soru', type: 'scenario', duration: 10, xp: 50 },
            { id: 6, lesson_id: 'CM-M9-U5-L6', title: '⚡ Zor Sorular Yarışı', type: 'timerace', duration: 5, xp: 55 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M9-U6',
          title: 'Şirket Bilgisi',
          description: 'Havayolunu araştır',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U6-L1', title: 'Şirketi Araştırma', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M9-U6-L2', title: 'Neden Bu Havayolu Sorusu', type: 'lesson', duration: 5, xp: 30 },
            { id: 3, lesson_id: 'CM-M9-U6-L3', title: 'Senaryo: Şirket Bilgisi', type: 'scenario', duration: 8, xp: 45 },
            { id: 4, lesson_id: 'CM-M9-U6-L4', title: '🎮 Şirket Bilgisi Doğru/Yanlış', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 7,
          unit_id: 'CM-M9-U7',
          title: 'Soru Sorma',
          description: 'Mülakat sonunda',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U7-L1', title: 'Mülakat Sonunda Soru Sorma', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M9-U7-L2', title: 'Sorulabilecek Sorular', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M9-U7-L3', title: 'Senaryo: Soru Sorma', type: 'scenario', duration: 8, xp: 40 },
          ]
        },
        {
          id: 8,
          unit_id: 'CM-M9-U8',
          title: '🎓 Final Simülasyonlar',
          description: 'Tam mülakat deneyimi',
          type: 'exam',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M9-U8-L1', title: 'Tam Simülasyon: Açılış', type: 'scenario', duration: 10, xp: 50 },
            { id: 2, lesson_id: 'CM-M9-U8-L2', title: 'Tam Simülasyon: Zor An', type: 'scenario', duration: 10, xp: 50 },
            { id: 3, lesson_id: 'CM-M9-U8-L3', title: 'Tam Simülasyon: Kapanış', type: 'scenario', duration: 10, xp: 50 },
            { id: 4, lesson_id: 'CM-M9-U8-L4', title: '🎓 Birebir Mülakat Final Quiz', type: 'exam', duration: 15, xp: 100 },
          ]
        },
      ]
    },
    
    module_10: {
      id: 'module_10',
      module_id: 10,
      title: 'Final Değerlendirme',
      subtitle: 'Hazırlık durumu',
      icon: '🏆',
      color: 'from-yellow-500 to-amber-600',
      bgColor: 'bg-yellow-500',
      estimatedTime: 45,
      totalUnits: 3,
      isFinal: true,
      units: [
        {
          id: 1,
          unit_id: 'CM-M10-U1',
          title: 'Kapsamlı Tekrar',
          description: 'Tüm konuların tekrarı',
          type: 'review',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M10-U1-L1', title: 'Modül 1-5 Tekrar', type: 'review', duration: 10, xp: 30 },
            { id: 2, lesson_id: 'CM-M10-U1-L2', title: 'Modül 6-9 Tekrar', type: 'review', duration: 10, xp: 30 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M10-U2',
          title: 'Final Simülasyonu',
          description: 'Tam mülakat deneyimi',
          type: 'simulation',
          score: 30,
          lessons: [
            { id: 1, lesson_id: 'CM-M10-U2-L1', title: 'Grup Mülakatı Final', type: 'scenario', duration: 15, xp: 50 },
            { id: 2, lesson_id: 'CM-M10-U2-L2', title: 'Birebir Mülakat Final', type: 'scenario', duration: 15, xp: 50 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-FINAL',
          title: 'Final Sınavı',
          description: 'Genel değerlendirme',
          type: 'exam',
          score: 50,
          lessons: [
            { id: 1, lesson_id: 'CM-FINAL-EXAM', title: '🎓 FİNAL SINAVI', type: 'exam', duration: 30, xp: 200 },
          ]
        },
      ],
      final_result: {
        ready: { threshold: 85, label: '✅ Mülakata Hazır', color: 'text-green-600' },
        conditional: { threshold: 70, label: '⚠️ Geliştirilmeli', color: 'text-yellow-600' },
        not_ready: { threshold: 0, label: '❌ Şu An Uygun Değil', color: 'text-red-600' }
      }
    },

    // ==================== MODÜL 11: TÜRK HAVAYOLLARI ====================
    module_11: {
      id: 'module_11',
      module_id: 11,
      title: 'Türk Havayolları Şirketleri',
      subtitle: 'THY, Pegasus, SunExpress, AnadoluJet, MGA',
      icon: '🇹🇷',
      color: 'from-red-500 to-red-700',
      bgColor: 'bg-red-600',
      estimatedTime: 65,
      totalUnits: 8,
      units: [
        {
          id: 1,
          unit_id: 'CM-M11-U1',
          title: 'Turkish Airlines (THY)',
          description: 'Türk Hava Yolları',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M11-U1-L1', title: 'THY Tarihi ve Vizyonu', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M11-U1-L2', title: 'THY Filo Yapısı', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M11-U1-L3', title: 'THY Hub ve Destinasyonlar', type: 'lesson', duration: 5, xp: 20 },
            { id: 4, lesson_id: 'CM-M11-U1-L4', title: 'THY Kabin Ekibi Beklentileri', type: 'lesson', duration: 5, xp: 25 },
            { id: 5, lesson_id: 'CM-M11-U1-L5', title: '🎮 THY Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M11-U2',
          title: 'Pegasus Airlines',
          description: 'Türkiye\'nin LCC\'si',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M11-U2-L1', title: 'Pegasus Tarihi', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M11-U2-L2', title: 'Pegasus İş Modeli', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M11-U2-L3', title: 'Pegasus Filo ve Rotalar', type: 'lesson', duration: 5, xp: 20 },
            { id: 4, lesson_id: 'CM-M11-U2-L4', title: '🎮 Pegasus Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M11-U3',
          title: 'SunExpress',
          description: 'THY-Lufthansa ortaklığı',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M11-U3-L1', title: 'SunExpress Hikayesi', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M11-U3-L2', title: 'SunExpress Operasyonu', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M11-U3-L3', title: '🎮 SunExpress Quiz', type: 'quiz', duration: 5, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M11-U4',
          title: 'AnadoluJet',
          description: 'THY\'nin iç hat markası',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M11-U4-L1', title: 'AnadoluJet Hakkında', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M11-U4-L2', title: 'AnadoluJet vs THY', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M11-U4-L3', title: '🎮 AnadoluJet Quiz', type: 'quiz', duration: 5, xp: 30 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M11-U5',
          title: 'MNG Airlines & Diğerleri',
          description: 'Kargo ve charter',
          type: 'lesson',
          score: 10,
          lessons: [
            { id: 1, lesson_id: 'CM-M11-U5-L1', title: 'MNG Airlines', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M11-U5-L2', title: 'Corendon, Freebird, Tailwind', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M11-U5-L3', title: '🎮 Türk Havayolları Final', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 7,
          unit_id: 'CM-M11-U7',
          title: 'MGA Havayolları',
          description: 'Mavi Gök Airlines',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M11-U7-L1', title: 'MGA Havayolları Hakkında', type: 'lesson', duration: 5, xp: 20 },
            { id: 2, lesson_id: 'CM-M11-U7-L2', title: 'MGA Havayolları', type: 'lesson', duration: 5, xp: 20 },
            { id: 3, lesson_id: 'CM-M11-U7-L3', title: '🎮 MGA Havayolları Quiz', type: 'quiz', duration: 5, xp: 30 },
          ]
        }
      ]
    },

    // ==================== MODÜL 12: YABANCI HAVAYOLLARI ====================
    module_12: {
      id: 'module_12',
      module_id: 12,
      title: 'Dünya Havayolları',
      subtitle: 'Emirates, Qatar, Lufthansa, BA...',
      icon: '🌍',
      color: 'from-blue-600 to-indigo-700',
      bgColor: 'bg-blue-600',
      estimatedTime: 50,
      totalUnits: 5,
      units: [
        {
          id: 1,
          unit_id: 'CM-M12-U1',
          title: 'Körfez Havayolları',
          description: 'Emirates, Qatar, Etihad',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M12-U1-L1', title: 'Emirates Airlines', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M12-U1-L2', title: 'Qatar Airways', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M12-U1-L3', title: 'Etihad Airways', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M12-U1-L4', title: '🎮 Körfez Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M12-U2',
          title: 'Avrupa Havayolları',
          description: 'Lufthansa, BA, Air France',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M12-U2-L1', title: 'Lufthansa Group', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M12-U2-L2', title: 'British Airways', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M12-U2-L3', title: 'Air France-KLM', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M12-U2-L4', title: '🎮 Avrupa Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M12-U3',
          title: 'Asya-Pasifik',
          description: 'Singapore, Cathay, ANA',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M12-U3-L1', title: 'Singapore Airlines', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M12-U3-L2', title: 'Cathay Pacific & ANA', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M12-U3-L3', title: '🎮 Asya Quiz', type: 'quiz', duration: 5, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M12-U4',
          title: 'Amerika Havayolları',
          description: 'Delta, United, American',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M12-U4-L1', title: 'ABD Big Three', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M12-U4-L2', title: '🎮 Amerika Quiz', type: 'quiz', duration: 5, xp: 35 },
          ]
        }
      ]
    },

    // ==================== MODÜL 13: UÇAK TİPLERİ & KABİN ====================
    module_13: {
      id: 'module_13',
      module_id: 13,
      title: 'Uçak Tipleri & Kabin',
      subtitle: 'Boeing, Airbus, kabin düzeni',
      icon: '✈️',
      color: 'from-slate-600 to-slate-800',
      bgColor: 'bg-slate-700',
      estimatedTime: 45,
      totalUnits: 5,
      units: [
        {
          id: 1,
          unit_id: 'CM-M13-U1',
          title: 'Airbus Ailesi',
          description: 'A320, A330, A350, A380',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M13-U1-L1', title: 'Airbus A320 Ailesi', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M13-U1-L2', title: 'Airbus Geniş Gövde', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M13-U1-L3', title: '🎮 Airbus Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M13-U2',
          title: 'Boeing Ailesi',
          description: '737, 777, 787, 747',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M13-U2-L1', title: 'Boeing 737 Ailesi', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M13-U2-L2', title: 'Boeing Geniş Gövde', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M13-U2-L3', title: '🎮 Boeing Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M13-U3',
          title: 'Kabin Düzeni',
          description: 'Galley, lavatory, exit',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M13-U3-L1', title: 'Kabin Bölümleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M13-U3-L2', title: 'Acil Çıkışlar', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M13-U3-L3', title: 'Koltuk Düzenleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M13-U3-L4', title: '🎮 Kabin Eşleştirme', type: 'matching', duration: 4, xp: 35 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M13-U4',
          title: 'Uçak Tanıma',
          description: 'Görsel farklar',
          type: 'game',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M13-U4-L1', title: 'Boeing vs Airbus Farkları', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M13-U4-L2', title: '⚡ Uçak Tanıma Yarışı', type: 'timerace', duration: 4, xp: 50 },
            { id: 3, lesson_id: 'CM-M13-U4-L3', title: '🎮 Doğru/Yanlış: Uçaklar', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M13-U5',
          title: 'Ünite Sınavı',
          description: 'Tüm bilgileri test et',
          type: 'quiz',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M13-U5-L1', title: '🎓 Uçak & Kabin Final', type: 'exam', duration: 10, xp: 80 },
          ]
        }
      ]
    },

    // ==================== MODÜL 14: ACİL DURUM PROSEDÜRLERİ ====================
    module_14: {
      id: 'module_14',
      module_id: 14,
      title: 'Acil Durum Prosedürleri',
      subtitle: 'Tahliye, yangın, ilkyardım',
      icon: '🚨',
      color: 'from-orange-500 to-red-600',
      bgColor: 'bg-orange-600',
      estimatedTime: 55,
      totalUnits: 6,
      units: [
        {
          id: 1,
          unit_id: 'CM-M14-U1',
          title: 'Tahliye Prosedürleri',
          description: 'Acil iniş ve tahliye',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M14-U1-L1', title: 'Tahliye Türleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M14-U1-L2', title: 'Komutlar ve İletişim', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M14-U1-L3', title: 'Slide ve Raft Kullanımı', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M14-U1-L4', title: '🎮 Tahliye Sıralaması', type: 'dragdrop', duration: 4, xp: 40 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M14-U2',
          title: 'Yangın Söndürme',
          description: 'Fire fighting',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M14-U2-L1', title: 'Yangın Tipleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M14-U2-L2', title: 'Söndürücü Kullanımı', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M14-U2-L3', title: '🎮 Yangın Senaryosu', type: 'scenario', duration: 8, xp: 45 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M14-U3',
          title: 'Ani Basınç Kaybı',
          description: 'Decompression',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M14-U3-L1', title: 'Decompression Tipleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M14-U3-L2', title: 'Oksijen Maskesi Prosedürü', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M14-U3-L3', title: '🎮 Basınç Kaybı Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M14-U4',
          title: 'Tıbbi Acil Durumlar',
          description: 'İlk yardım',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M14-U4-L1', title: 'Temel İlk Yardım', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M14-U4-L2', title: 'CPR ve AED', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M14-U4-L3', title: 'Yaygın Tıbbi Durumlar', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M14-U4-L4', title: '🎮 Tıbbi Senaryo', type: 'scenario', duration: 8, xp: 45 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M14-U5',
          title: 'Güvenlik Tehditleri',
          description: 'Hijack, bomb threat',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M14-U5-L1', title: 'Güvenlik Prosedürleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M14-U5-L2', title: 'Şüpheli Durum Yönetimi', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M14-U5-L3', title: '🎮 Güvenlik Senaryosu', type: 'scenario', duration: 8, xp: 45 },
          ]
        },
        {
          id: 6,
          unit_id: 'CM-M14-U6',
          title: '🎮 Acil Durum Oyunları',
          description: 'Hızlı karar ver!',
          type: 'game',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M14-U6-L1', title: '⚡ Acil Durum Yarışı', type: 'timerace', duration: 5, xp: 60 },
            { id: 2, lesson_id: 'CM-M14-U6-L2', title: '🎮 Doğru/Yanlış: Acil', type: 'truefalse', duration: 4, xp: 40 },
          ]
        }
      ]
    },

    // ==================== MODÜL 15: YOLCU HİZMETLERİ ====================
    module_15: {
      id: 'module_15',
      module_id: 15,
      title: 'Yolcu Hizmetleri',
      subtitle: 'Servis, VIP, özel yolcular',
      icon: '🍽️',
      color: 'from-amber-500 to-orange-600',
      bgColor: 'bg-amber-600',
      estimatedTime: 45,
      totalUnits: 5,
      units: [
        {
          id: 1,
          unit_id: 'CM-M15-U1',
          title: 'Kabin Servisi',
          description: 'Yemek ve içecek',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M15-U1-L1', title: 'Servis Prosedürleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M15-U1-L2', title: 'Trolley Yönetimi', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M15-U1-L3', title: 'Özel Yemekler (SPML)', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M15-U1-L4', title: '🎮 Servis Sıralaması', type: 'dragdrop', duration: 4, xp: 40 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M15-U2',
          title: 'Özel Yolcular',
          description: 'VIP, UM, PRM, WCHC',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M15-U2-L1', title: 'VIP ve CIP Yolcular', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M15-U2-L2', title: 'Refakatsiz Çocuklar (UM)', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M15-U2-L3', title: 'Engelli Yolcular (PRM)', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M15-U2-L4', title: '🎮 Yolcu Kodu Eşleştir', type: 'matching', duration: 4, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M15-U3',
          title: 'Zor Yolcular',
          description: 'Şikayetler ve çözümler',
          type: 'scenario',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M15-U3-L1', title: 'Şikayet Yönetimi', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M15-U3-L2', title: 'Alkollü Yolcu', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M15-U3-L3', title: '🎮 Zor Yolcu Senaryoları', type: 'scenario', duration: 10, xp: 50 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M15-U4',
          title: 'Duty Free Satış',
          description: 'Satış teknikleri',
          type: 'lesson',
          score: 15,
          lessons: [
            { id: 1, lesson_id: 'CM-M15-U4-L1', title: 'Duty Free Prosedürü', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M15-U4-L2', title: 'Satış Teknikleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M15-U4-L3', title: '🎮 Satış Quiz', type: 'quiz', duration: 5, xp: 35 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M15-U5',
          title: '🎮 Servis Oyunları',
          description: 'Hızlı servis!',
          type: 'game',
          score: 25,
          lessons: [
            { id: 1, lesson_id: 'CM-M15-U5-L1', title: '⚡ Servis Zaman Yarışı', type: 'timerace', duration: 4, xp: 50 },
            { id: 2, lesson_id: 'CM-M15-U5-L2', title: '🎮 Boşluk Doldur: Servis', type: 'fillin', duration: 4, xp: 40 },
          ]
        }
      ]
    },

    // ==================== MODÜL 16: HAVACILIK TERİMLERİ ====================
    module_16: {
      id: 'module_16',
      module_id: 16,
      title: 'Havacılık Terimleri',
      subtitle: 'Kodlar, alfabe, terimler',
      icon: '📖',
      color: 'from-violet-500 to-purple-700',
      bgColor: 'bg-violet-600',
      estimatedTime: 40,
      totalUnits: 5,
      units: [
        {
          id: 1,
          unit_id: 'CM-M16-U1',
          title: 'ICAO Alfabesi',
          description: 'Alpha, Bravo, Charlie...',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M16-U1-L1', title: 'Fonetik Alfabe', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M16-U1-L2', title: 'Alfabe Pratiği', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M16-U1-L3', title: '🎮 Alfabe Eşleştirme', type: 'matching', duration: 4, xp: 40 },
            { id: 4, lesson_id: 'CM-M16-U1-L4', title: '⚡ Alfabe Yarışı', type: 'timerace', duration: 4, xp: 50 },
          ]
        },
        {
          id: 2,
          unit_id: 'CM-M16-U2',
          title: 'Havaalanı Kodları',
          description: 'IATA ve ICAO kodları',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M16-U2-L1', title: 'IATA Kodları', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M16-U2-L2', title: 'Türkiye Havaalanları', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M16-U2-L3', title: 'Dünya Hub\'ları', type: 'lesson', duration: 5, xp: 25 },
            { id: 4, lesson_id: 'CM-M16-U2-L4', title: '🎮 Kod Eşleştirme', type: 'matching', duration: 4, xp: 40 },
          ]
        },
        {
          id: 3,
          unit_id: 'CM-M16-U3',
          title: 'Kabin Terimleri',
          description: 'Galley, PAX, ETA...',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M16-U3-L1', title: 'Temel Kabin Terimleri', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M16-U3-L2', title: 'Operasyonel Terimler', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M16-U3-L3', title: '🎮 Terim Quiz', type: 'quiz', duration: 5, xp: 40 },
          ]
        },
        {
          id: 4,
          unit_id: 'CM-M16-U4',
          title: 'Yolcu Kodları',
          description: 'SSR, SPML kodları',
          type: 'lesson',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M16-U4-L1', title: 'SSR Kodları', type: 'lesson', duration: 5, xp: 25 },
            { id: 2, lesson_id: 'CM-M16-U4-L2', title: 'Yemek Kodları (SPML)', type: 'lesson', duration: 5, xp: 25 },
            { id: 3, lesson_id: 'CM-M16-U4-L3', title: '🎮 Kod Doğru/Yanlış', type: 'truefalse', duration: 4, xp: 35 },
          ]
        },
        {
          id: 5,
          unit_id: 'CM-M16-U5',
          title: '🎮 Terim Finali',
          description: 'Tüm terimleri test et!',
          type: 'game',
          score: 20,
          lessons: [
            { id: 1, lesson_id: 'CM-M16-U5-L1', title: '⚡ Mega Terim Yarışı', type: 'timerace', duration: 5, xp: 60 },
            { id: 2, lesson_id: 'CM-M16-U5-L2', title: '🎮 Boşluk Doldur: Terimler', type: 'fillin', duration: 4, xp: 40 },
            { id: 3, lesson_id: 'CM-M16-U5-L3', title: '🎓 Terimler Final Sınavı', type: 'exam', duration: 10, xp: 80 },
          ]
        }
      ]
    }
  }
};

// Modül listesini array olarak al
export const getCabinModulesArray = () => {
  return Object.values(cabinCrewCurriculum.modules);
};

// Belirli bir modülü al
export const getCabinModule = (moduleId) => {
  return cabinCrewCurriculum.modules[`module_${moduleId}`];
};

export default cabinCrewCurriculum;
